import OffCanvas from "../ui/OffCanvas";
import React from "react";
import Card from "../ui/card/Card";
import Stack from "../ui/Stack";
import {Link} from "react-router-dom";
import Button from "../common/button/Button";

const NotificationSidebar=()=>{
    return(
        <>
            {/*Notification Center*/}
            <OffCanvas id="notificationOffcanvas" title="Notification Center" placement="end" width={450}>
               <Card className="bg-primary bg-opacity-15">
                   <p className="fs-sm m-1 text-primary text-end">Thu, Aug 28, 2025, 05:54 PM</p>
                   <p className="fs-sm m-0 text-primary fw-medium">Sync of [mserp_hcmemploymentv2entity] has been completed.</p>

                   <Stack className="justify-content-end">
                       <Link className="fs-sm me-3 text-bg-light">Click here</Link>
                       <Button className="bg-transparent fs-sm p-0 text-bg-light fw-normal"><span className="fw-normal">Close</span></Button>
                   </Stack>
               </Card>
            </OffCanvas>
        </>
    )
}

export default NotificationSidebar;